module.exports = __webpack_public_path__ + "static/media/location13.74044015.jpg";